export default {
  PROJECT: 'ALGONOMY_',
  // API: 'https://hp-salesplan-app-uat.algonomy.com',
  // API: 'https://euhpplanning-dev-spapp.algonomy.com',
  API: 'https://hp-salesplan-app.algonomy.com',
  // API: 'http://localhost:8031',
  // LOGOUT_URL: 'https://hp-salesplan-uat.algonomy.com',
  // LOGOUT_URL: 'https://euhpplanning-spdev.algonomy.com',
  LOGOUT_URL: 'https://hp-salesplan.algonomy.com',
  // LOGOUT_URL: 'http://localhost:3000',
  ITEMS_PER_PAGE: 150,
}
